import { Box, Typography } from '@mui/material';
import React from 'react';
import { formatInTimeZone } from 'date-fns-tz';
import { convertTokens } from '@date-fns/upgrade/v2';

import { mediumGray } from 'utils/color-styles';

import { Opportunity } from '../types';

export const OpportunityDate = ({ opportunity }: { opportunity: Opportunity }) => {
  const timeZone =
    opportunity.timeZone && !opportunity.virtual
      ? opportunity.timeZone
      : Intl.DateTimeFormat()?.resolvedOptions()?.timeZone;

  return (
    <>
      {opportunity.startingAt ? (
        <Box py={2} borderTop={`1px solid ${mediumGray}`}>
          <Typography>
            Date: {formatInTimeZone(opportunity.startingAt, timeZone, convertTokens('DD MMMM'))}{' '}
          </Typography>
        </Box>
      ) : null}
      {(opportunity.startingAt || opportunity.endingAt) && (
        <Box py={2} borderTop={`1px solid ${mediumGray}`}>
          <Typography>
            Time:{' '}
            {opportunity.startingAt &&
              formatInTimeZone(opportunity.startingAt, timeZone, convertTokens('hh:mmA'))}
            {opportunity.endingAt && opportunity.endingAt !== opportunity.startingAt && (
              <> – {formatInTimeZone(opportunity.endingAt, timeZone, convertTokens('hh:mmA'))}</>
            )}
          </Typography>
        </Box>
      )}
    </>
  );
};
